import { MagicVariables } from '@/types';
import { VideoEdition } from './types';
import { VIDEO_LINKS, DEFAULT_EDITION } from './utils';

export class AgeVerification implements MagicVariables {
    isDesktopPlaying = false;
    isMobilePlaying = false;
    $refs?: MagicVariables['$refs'];
    videoSrc = VIDEO_LINKS[DEFAULT_EDITION];

    constructor(cocCookie: VideoEdition) {
        this.determineVideoEdition(cocCookie);
    }

    determineVideoEdition(coc: VideoEdition) {
        if (coc === 'fr') { this.videoSrc = VIDEO_LINKS[coc]; }
    }

    loadVideo() {
        if (this.$refs?.desktopVideo && this.$refs?.mobileVideo) {
            (this.$refs.desktopVideo as HTMLMediaElement).load();
            (this.$refs.mobileVideo as HTMLMediaElement).load();
        }
    }

    // Mobile video controls
    playMobileVideo() {
        (this.$refs.mobileVideo as HTMLMediaElement).play();
        this.isMobilePlaying = true;
    }

    stopMobileVideo() {
        (this.$refs.mobileVideo as HTMLMediaElement).pause();
        this.isMobilePlaying = false;
        (this.$refs.mobileVideo as HTMLMediaElement).currentTime = 0;
    }

    enterFullscreen() {
        const video = (this.$refs.mobileVideo as any);
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
        } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
        } else { console.log('Fullscreen API not supported'); }
    }

    // Desktop video controls
    playDesktopVideo() {
        (this.$refs.desktopVideo as HTMLMediaElement).play();
        this.isDesktopPlaying = true;
    }

    stopDesktopVideo() {
        (this.$refs.desktopVideo as HTMLMediaElement).pause();
        this.isDesktopPlaying = false;
        (this.$refs.desktopVideo as HTMLMediaElement).currentTime = 0;
    }
}
